export default "__VITE_ASSET__D$3v4Xx2__"